/**
 * Registers the Vite PWA service worker, but only when:
 *  - we're NOT inside an iframe (Lovable preview lives in an iframe)
 *  - we're NOT on a Lovable preview/sandbox host
 *
 * On those preview hosts we instead unregister any previously installed SW
 * so the editor preview never serves a stale cached shell.
 */
export async function registerSW() {
  if (typeof window === "undefined") return;

  const inIframe = (() => {
    try { return window.self !== window.top; } catch { return true; }
  })();

  const host = window.location.hostname;
  const isPreviewHost =
    host.includes("id-preview--") ||
    host.includes("preview--") ||
    host.endsWith(".lovableproject.com") ||
    host.endsWith(".lovableproject-dev.com") ||
    host === "localhost" ||
    host === "127.0.0.1";

  if (inIframe || isPreviewHost) {
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations().catch(() => []);
      await Promise.all(regs.map((r) => r.unregister()));
    }
    return;
  }

  // Lazy-load workbox-window only on real installs.
  try {
    const { Workbox } = await import("workbox-window");
    if (!("serviceWorker" in navigator)) return;
    const wb = new Workbox("/sw.js", { scope: "/" });
    wb.addEventListener("waiting", () => {
      // Auto-activate the new worker — combined with NetworkFirst on HTML
      // this gives users the latest build on next navigation.
      wb.messageSkipWaiting();
    });
    wb.register().catch((e) => console.warn("[PWA] register failed", e));
  } catch (e) {
    console.warn("[PWA] disabled", e);
  }
}